(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-delivery"] && !Shopify.designMode) return;
  try {
    (function () {
    var ZONE = 'America/New_York';
    var MONTHS = { Jan: '01', Feb: '02', Mar: '03', Apr: '04', May: '05', Jun: '06', Jul: '07', Aug: '08', Sep: '09', Oct: '10', Nov: '11', Dec: '12' };

    function parts(date, extra) {
      var bag = {};
      new Intl.DateTimeFormat('en-US', Object.assign({ timeZone: ZONE, hourCycle: 'h23' }, extra)).formatToParts(date).forEach(function (part) {
        if (part.type !== 'literal') bag[part.type] = part.value;
      });
      return bag;
    }

    function nowInZone() {
      return parts(new Date(), { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', weekday: 'short' });
    }

    function shift(now, days, months) {
      var date = new Date(Date.UTC(Number(now.year), Number(now.month) - 1 + (months || 0), Number(now.day) + (days || 0), 17, 0, 0));
      var bag = parts(date, { year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short' });
      var named = parts(date, { month: 'short', day: 'numeric', weekday: 'short' });
      bag.iso = bag.year + '-' + bag.month + '-' + bag.day;
      bag.short = named.weekday + ', ' + named.month + ' ' + named.day;
      bag.label = bag.short + ', ' + bag.year;
      return bag;
    }

    function sameDayOpen(now) {
      var openDay = now.weekday === 'Mon' || now.weekday === 'Tue' || now.weekday === 'Wed' || now.weekday === 'Thu' || now.weekday === 'Fri';
      return openDay && Number(now.hour) < 14;
    }

    function bounds() {
      var now = nowInZone();
      var open = sameDayOpen(now);
      var earliest = shift(now, open ? 0 : 1, 0);
      var latest = shift({ year: earliest.iso.slice(0, 4), month: earliest.iso.slice(5, 7), day: earliest.iso.slice(8, 10) }, 0, 6);
      return { open: open, earliest: earliest, latest: latest, weekday: now.weekday };
    }

    function labelToIso(label) {
      var match = String(label || '').match(/([A-Za-z]{3}) (\d{1,2}), (\d{4})/);
      if (!match || !MONTHS[match[1]]) return '';
      var day = match[2].length === 1 ? '0' + match[2] : match[2];
      return match[3] + '-' + MONTHS[match[1]] + '-' + day;
    }

    function zipSource(root) {
      if (root.getAttribute('data-zip-src')) return root.getAttribute('data-zip-src');
      var holder = root.closest('[data-zip-src]');
      return holder ? holder.getAttribute('data-zip-src') : '';
    }

    function ensureZipData(src) {
      if (window.cpHasUsZip) return Promise.resolve();
      if (!src) return Promise.reject(new Error('zip'));
      if (!window.cpZipLoading) {
        window.cpZipLoading = new Promise(function (resolve, reject) {
          var script = document.createElement('script');
          script.src = src;
          script.onload = function () {
            if (window.cpHasUsZip) resolve();
            else reject(new Error('zip'));
          };
          script.onerror = function () { reject(new Error('zip')); };
          document.head.appendChild(script);
        });
      }
      return window.cpZipLoading;
    }

    function normalizeZip(value) {
      var cleaned = String(value || '').replace(/\s+/g, '');
      if (/^\d{5}$/.test(cleaned)) return cleaned;
      if (/^\d{5}-\d{4}$/.test(cleaned)) return cleaned;
      if (/^\d{9}$/.test(cleaned)) return cleaned.slice(0, 5) + '-' + cleaned.slice(5);
      return '';
    }

    function zipStatus(value) {
      var formatted = normalizeZip(value);
      if (!formatted) return { state: String(value || '').trim() ? 'format' : 'empty', formatted: '' };
      if (!window.cpHasUsZip) return { state: 'loading', formatted: formatted };
      if (!window.cpHasUsZip(formatted.slice(0, 5))) return { state: 'unknown', formatted: formatted };
      return { state: 'ok', formatted: formatted };
    }

    function zipError(status) {
      if (status.state === 'empty') return 'Enter a delivery ZIP code.';
      if (status.state === 'unknown') return 'Enter a recognized US ZIP code.';
      return 'Enter a US ZIP code. Codes outside the United States are not accepted.';
    }

    function applySaved(root) {
      var savedDate = labelToIso(root.dataset.savedDate);
      var savedZip = root.dataset.savedZip || '';
      if (savedDate) root.querySelector('[data-delivery-input]').value = savedDate;
      if (savedZip) root.querySelector('[data-zip-input]').value = savedZip;
    }

    function availability(place, range) {
      if (!window.cpPlace) return 'Enter the delivery ZIP to see if same-day delivery is still open.';
      return window.cpPlace.deliveryNote({
        zone: place.zone,
        known: place.known,
        place: place.place,
        zip: place.zip,
        open: range.open,
        weekday: range.weekday,
        earliest: range.earliest.short
      });
    }

    function placeContext(status, manual) {
      if (!window.cpPlace) return { zone: 'America/New_York', known: false, place: '', zip: false };
      if (status.state === 'empty') window.cpPlace.clearZip();
      if (status.state === 'ok') return window.cpPlace.noteContext(true, status.formatted, manual === true);
      return window.cpPlace.noteContext(false, '');
    }

    function sync(root) {
      var dateInput = root.querySelector('[data-delivery-input]');
      var dateValue = root.querySelector('[data-delivery-value]');
      var zipInput = root.querySelector('[data-zip-input]');
      var zipValue = root.querySelector('[data-zip-value]');
      var zipConfirm = root.querySelector('[data-zip-confirm]');
      var note = root.querySelector('[data-delivery-note]');
      if (window.cpPlace && root.dataset.userZip !== '1') {
        var savedPlace = window.cpPlace.read();
        if (savedPlace && savedPlace.source === 'zip' && savedPlace.zip) zipInput.value = savedPlace.zip;
      }
      var status = zipStatus(zipInput.value);
      var place = placeContext(status, root.dataset.userZip === '1');
      ZONE = place.zone;
      var range = bounds();
      dateInput.min = range.earliest.iso;
      dateInput.max = range.latest.iso;
      if (!dateInput.value || dateInput.value < range.earliest.iso || dateInput.value > range.latest.iso) {
        dateInput.value = range.earliest.iso;
      }
      var picked = shift({ year: dateInput.value.slice(0, 4), month: dateInput.value.slice(5, 7), day: dateInput.value.slice(8, 10) }, 0, 0);
      dateValue.value = picked.label;
      if (status.state === 'ok') {
        zipValue.value = status.formatted;
        zipConfirm.hidden = false;
        zipConfirm.textContent = 'A local florist will deliver to ' + status.formatted + '. ' + availability(place, range);
      } else {
        zipValue.value = '';
        zipConfirm.hidden = true;
        zipConfirm.textContent = '';
        if (status.state === 'loading') {
          ensureZipData(zipSource(root)).then(function () {
            if (root.isConnected) sync(root);
          }).catch(function () {});
        }
      }
      note.textContent = availability(place, range);
      return range;
    }

    function showError(root, message) {
      var error = root.querySelector('[data-delivery-error]');
      error.hidden = false;
      error.textContent = message;
    }

    function validChoice(root) {
      sync(root);
      var range = bounds();
      var dateInput = root.querySelector('[data-delivery-input]');
      if (dateInput.value < range.earliest.iso) {
        showError(root, 'Choose ' + range.earliest.short + ' or a later date.');
        dateInput.focus();
        return false;
      }
      var zipInput = root.querySelector('[data-zip-input]');
      var status = zipStatus(zipInput.value);
      if (status.state !== 'ok') {
        if (status.state !== 'loading') showError(root, zipError(status));
        zipInput.focus();
        return false;
      }
      root.querySelector('[data-delivery-error]').hidden = true;
      return true;
    }

    function rootPath() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }

    function persist(root) {
      if (root.dataset.saving === 'true') return root._savePromise || Promise.resolve(false);
      if (!validChoice(root)) return Promise.resolve(false);
      root.dataset.saving = 'true';
      var dateLabel = root.querySelector('[data-delivery-value]').value;
      var zipLabel = root.querySelector('[data-zip-value]').value;
      root._savePromise = fetch(rootPath() + 'cart.js', { credentials: 'same-origin' })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          var chain = Promise.resolve();
          cart.items.slice().reverse().forEach(function (item, offset) {
            var line = cart.items.length - offset;
            chain = chain.then(function () {
              var properties = {};
              var current = item.properties || {};
              Object.keys(current).forEach(function (key) {
                if (current[key]) properties[key] = String(current[key]);
              });
              delete properties['Preferred delivery time'];
              properties['Delivery date'] = dateLabel;
              properties['Delivery zip code'] = zipLabel;
              return fetch(rootPath() + 'cart/change.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ line: line, quantity: item.quantity, properties: properties })
              }).then(function (response) {
                if (!response.ok) throw new Error('save');
              });
            });
          });
          return chain.then(function () {
            document.querySelectorAll('dt, strong').forEach(function (node) {
              var label = node.textContent.replace(':', '').trim();
              var value = node.parentElement && node.parentElement.querySelector('dd');
              if (!value) return;
              if (label === 'Delivery date') value.textContent = dateLabel;
              if (label === 'Delivery zip code') value.textContent = zipLabel;
            });
            return fetch(rootPath() + 'cart/update.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ attributes: { 'Delivery zip code': zipLabel } })
            }).then(function () {
              document.querySelectorAll('[data-cart-delivery]').forEach(function (other) {
                if (other === root) return;
                other.dataset.savedDate = dateLabel;
                other.dataset.savedZip = zipLabel;
                applySaved(other);
                sync(other);
              });
              return true;
            });
          });
        })
        .catch(function () {
          showError(root, 'The delivery date could not be saved. Try again.');
          return false;
        })
        .finally(function () {
          root.dataset.saving = 'false';
        });
      return root._savePromise;
    }

    window.addEventListener('cp-place', function () {
      document.querySelectorAll('[data-cart-delivery]').forEach(function (root) {
        if (root.dataset.ready !== 'true') return;
        var zipInput = root.querySelector('[data-zip-input]');
        var saved = window.cpPlace && window.cpPlace.read();
        if (zipInput && saved && saved.source === 'zip' && saved.zip && root.dataset.userZip !== '1') zipInput.value = saved.zip;
        sync(root);
      });
    });

    function init(root) {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      applySaved(root);
      sync(root);
      root.querySelector('[data-delivery-input]').addEventListener('change', function () {
        root.querySelector('[data-delivery-error]').hidden = true;
        sync(root);
      });
      root.querySelector('[data-zip-input]').addEventListener('input', function () {
        root.dataset.userZip = '1';
        root.querySelector('[data-delivery-error]').hidden = true;
        sync(root);
      });
    }

    function openPrompt() {
      var dialog = document.querySelector('[data-delivery-dialog]');
      if (!dialog) return;
      var root = dialog.querySelector('[data-cart-delivery]');
      init(root);
      if (root) sync(root);
      if (!dialog.open) dialog.showModal();
    }

    function goToCheckout(root) {
      var zip = root.querySelector('[data-zip-value]').value;
      var params = new URLSearchParams();
      params.set('checkout[shipping_address][country]', 'US');
      params.set('checkout[shipping_address][zip]', zip);
      window.location.assign(rootPath() + 'checkout?' + params.toString());
    }

    function scan() {
      document.querySelectorAll('[data-cart-delivery]').forEach(init);
    }

    document.addEventListener('click', function (event) {
      var continueButton = event.target.closest && event.target.closest('[data-delivery-continue]');
      if (continueButton) {
        event.preventDefault();
        var dialog = continueButton.closest('[data-delivery-dialog]');
        var root = dialog && dialog.querySelector('[data-cart-delivery]');
        if (!root) return;
        continueButton.disabled = true;
        ensureZipData(zipSource(root)).then(function () {
          if (!validChoice(root)) {
            continueButton.disabled = false;
            return;
          }
          return persist(root).then(function (saved) {
            continueButton.disabled = false;
            if (!saved) return;
            goToCheckout(root);
          });
        }).catch(function () {
          continueButton.disabled = false;
          showError(root, 'We could not verify that ZIP code. Please try again.');
        });
        return;
      }
      var cancelButton = event.target.closest && event.target.closest('[data-delivery-cancel]');
      if (cancelButton) {
        var cancelDialog = cancelButton.closest('[data-delivery-dialog]');
        if (cancelDialog && cancelDialog.open) cancelDialog.close();
        return;
      }
      var button = event.target.closest && event.target.closest('button[name="checkout"], .checkout-btn, .cart__checkout-button');
      if (!button || button.hasAttribute('data-delivery-pay')) return;
      event.preventDefault();
      event.stopPropagation();
      window.location.assign(rootPath() + 'cart');
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || form.dataset.deliveryGo === 'true') return;
      var submitter = event.submitter;
      if (!submitter) return;
      if (submitter.name !== 'checkout' && !submitter.classList.contains('checkout-btn') && !submitter.classList.contains('cart__checkout-button')) return;
      event.preventDefault();
      event.stopPropagation();
      window.location.assign(rootPath() + 'cart');
    }, true);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scan);
    } else {
      scan();
    }
    var watch = document.body || document.documentElement;
    if (watch && window.MutationObserver) {
      new MutationObserver(scan).observe(watch, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-facts"] && !Shopify.designMode) return;
  try {
    if (!window.cpPdpFacts) {
    window.cpPdpFacts = true;
    document.addEventListener('click', function (event) {
      var tab = event.target.closest && event.target.closest('[data-pdp-tab]');
      if (!tab) return;
      var root = tab.closest('[data-pdp-facts]');
      root.querySelectorAll('[data-pdp-tab]').forEach(function (item) {
        var selected = item === tab;
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
        item.tabIndex = selected ? 0 : -1;
      });
      root.querySelectorAll('[data-pdp-panel]').forEach(function (panel) {
        panel.hidden = panel.id !== tab.getAttribute('aria-controls');
      });
    });
    document.addEventListener('keydown', function (event) {
      var tab = event.target.closest && event.target.closest('[data-pdp-tab]');
      if (!tab || (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft')) return;
      var tabs = Array.prototype.slice.call(tab.parentElement.querySelectorAll('[data-pdp-tab]'));
      var index = tabs.indexOf(tab);
      var next = event.key === 'ArrowRight' ? tabs[index + 1] || tabs[0] : tabs[index - 1] || tabs[tabs.length - 1];
      next.focus();
      next.click();
      event.preventDefault();
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["story-send-animation"] && !Shopify.designMode) return;
  try {
    (function () {
  var roots = document.querySelectorAll('[data-story-send]');
  if (!roots.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lottieNodes = [];

  function setPlaying(root, playing) {
    if (reduce) return;
    if (playing) root.setAttribute('data-playing', 'true');
    else root.removeAttribute('data-playing');
    var video = root.querySelector('video');
    if (video) {
      if (playing) video.play().catch(function () {});
      else video.pause();
    }
    if (root._lottie) {
      if (playing) root._lottie.play();
      else root._lottie.pause();
    }
  }

  roots.forEach(function (root) {
    if (reduce) return;
    if (!('IntersectionObserver' in window)) {
      setPlaying(root, true);
      return;
    }
    var watcher = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        setPlaying(root, entry.isIntersecting && entry.intersectionRatio >= 0.35);
      });
    }, { threshold: [0, 0.35, 0.6] });
    watcher.observe(root);
    if (root.getAttribute('data-lottie-url')) lottieNodes.push(root);
  });

  if (!lottieNodes.length || reduce) return;
  var script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/lottie-web@5.12.2/build/player/lottie.min.js';
  script.async = true;
  script.onload = function () {
    lottieNodes.forEach(function (root) {
      var holder = root.querySelector('.story-send-lottie');
      if (!holder || !window.lottie) return;
      root._lottie = window.lottie.loadAnimation({
        container: holder,
        renderer: 'svg',
        loop: true,
        autoplay: false,
        path: root.getAttribute('data-lottie-url')
      });
      if (root.getAttribute('data-playing') === 'true') root._lottie.play();
    });
  };
  document.head.appendChild(script);
})();
  } catch(e) { console.error(e); }
})();

})();
